// ===== Configurações =====
const ENABLE_LOOP_ON_BADGES = false; // loop infinito só nos badges (swatches nunca)
const ENABLE_DRAG_SCROLL    = true;  // arraste com mouse/touch

// seletor dos containers horizontais
const HSCROLL_SELECTORS = [
  '.product-card-layout-02 .card-swatch .swatch', // swatches (NÃO clonar)
  '.card-information__badges'                      // badges (pode clonar se habilitar)
];
const HSCROLL_SELECTOR = HSCROLL_SELECTORS.join(', ');

// sensibilidade do arraste
const TOUCH_DRAG_THRESHOLD_PX = 8;    // toque/pen
const MOUSE_DRAG_THRESHOLD_PX = 14;   // mouse (maior p/ não matar clique)
const DRAG_DOMINANCE          = 1.35; // |dx| > 1.35*|dy| => horizontal

(function () {
  // ===== helpers =====
  function isHorizOverflow(el) {
    return el && el.scrollWidth > el.clientWidth + 1;
  }

  function ensureLoopIfNeeded(container) {
    const isBadges   = container.matches('.card-information__badges');
    const shouldLoop = isBadges ? ENABLE_LOOP_ON_BADGES : false; // swatches nunca loop

    if (!shouldLoop) return;
    if (container.dataset.loopApplied === '1') return;
    if (!isHorizOverflow(container)) return;

    const items = Array.from(container.children);
    if (items.length < 2) return;

    container.dataset.loopApplied = '1';

    const originalCount = items.length;
    items.forEach(node => container.appendChild(node.cloneNode(true)));

    const firstBlockWidth = Array.from(container.children)
      .slice(0, originalCount)
      .reduce((w, el) => w + el.offsetWidth, 0);

    container.scrollLeft = firstBlockWidth;

    container.addEventListener('scroll', () => {
      const blockWidth = firstBlockWidth;
      if (container.scrollLeft >= blockWidth * 2) {
        container.scrollLeft -= blockWidth;
      } else if (container.scrollLeft <= 0) {
        container.scrollLeft += blockWidth;
      }
    }, { passive: true });
  }

  function bootstrapContainers(root = document) {
    root.querySelectorAll(HSCROLL_SELECTOR).forEach((container) => {
      if (container.__hscrollBootstrapped) return;
      container.__hscrollBootstrapped = true;

      // iOS/Android: vertical nativo, horizontal por JS
      if (!container.style.touchAction) container.style.touchAction = 'pan-y';

      // evita “ghost drag” nas imagens dentro
      container.querySelectorAll('img').forEach(img => { try { img.draggable = false; } catch (_) {} });

      // aplica loop só quando permitido (nunca em swatches)
      ensureLoopIfNeeded(container);
    });
  }

  // extrai url(...) do background-image
  function extractUrlFromBg(bg) {
    if (!bg) return null;
    const m = String(bg).match(/url\(\s*['"]?([^'")]+)['"]?\s*\)/i);
    return m ? m[1] : null;
  }

  // normaliza uma URL de imagem do CDN (usa como veio; se vier _small, mantém)
  function pickPrimaryFromLabel(label) {
    // prioridade para data-variant-img
    let src = label.getAttribute('data-variant-img') || label.dataset.variantImg || null;
    if (src) return src;

    // fallback: pega do background do .pattern
    const pat = label.querySelector('.pattern');
    if (pat) {
      const fromStyle = extractUrlFromBg(pat.style && pat.style.backgroundImage);
      if (fromStyle) return fromStyle;

      // tenta data-bg / data-src
      src = pat.getAttribute('data-bg') || pat.getAttribute('data-src') || pat.dataset.bg || pat.dataset.src || null;
      if (src) return src;
    }

    // tenta wrapper
    const wrap = label.closest('.item-wrapper, .item');
    if (wrap) {
      src = wrap.getAttribute('data-variant-img') || wrap.dataset.variantImg ||
            wrap.getAttribute('data-bg') || wrap.dataset.bg ||
            wrap.getAttribute('data-src') || wrap.dataset.src || null;
    }
    return src || null;
  }

  function pickHoverFromLabel(label) {
    // se você expuser data-variant-img2/data-hover-img, usamos
    let hover =
      label.getAttribute('data-variant-img2') || label.dataset.variantImg2 ||
      label.getAttribute('data-hover-img')    || label.dataset.hoverImg || null;

    if (!hover) {
      // tenta no wrapper também
      const wrap = label.closest('.item-wrapper, .item');
      if (wrap) {
        hover =
          wrap.getAttribute('data-variant-img2') || wrap.dataset.variantImg2 ||
          wrap.getAttribute('data-hover-img')    || wrap.dataset.hoverImg || null;
      }
    }
    return hover || null;
  }

  // atualiza imagens do card (principal + hover) para a variante selecionada
  function updateCardImagesForVariant(card, label) {
    if (!card || !label) return;

    const media = card.querySelector('.card-media');
    if (!media) return;

    const imgs = media.querySelectorAll('img');
    if (!imgs.length) return;

    const primary = pickPrimaryFromLabel(label);
    const hover   = pickHoverFromLabel(label) || primary; // fallback seguro

    // Atualiza a imagem principal
    if (primary) {
      const img0 = imgs[0];
      try {
        img0.src = primary;
        // zera srcset para não “voltar” para a anterior
        img0.removeAttribute('srcset');
        // remove lazy dataset que possa reverter
        img0.removeAttribute('data-src');
        img0.removeAttribute('data-srcset');
      } catch(_) {}
    }

    // Atualiza a imagem de hover (se existir)
    if (imgs[1]) {
      const img1 = imgs[1];
      try {
        img1.src = hover || primary || img1.src;
        img1.removeAttribute('srcset');
        img1.removeAttribute('data-src');
        img1.removeAttribute('data-srcset');
      } catch(_) {}
    }
  }

  // boot inicial + eventos do tema
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bootstrapContainers());
  } else {
    bootstrapContainers();
  }
  window.addEventListener('pageshow', () => bootstrapContainers());
  document.addEventListener('shopify:section:load',   e => bootstrapContainers(e.target || document));
  document.addEventListener('shopify:section:select', e => bootstrapContainers(e.target || document));

  // ===== drag/slide com Pointer Events (document-level) =====
  const activeDrags = new Map();   // pointerId -> {container, startX, startY, startScrollLeft, movedHoriz, isTouchLike}
  const justDragged = new WeakSet(); // suprimir clique pós-drag

  const getContainerFrom = (target) => {
    if (!target) return null;
    const el = target.closest(HSCROLL_SELECTOR);
    return el && (el instanceof HTMLElement) ? el : null;
  };

  if (ENABLE_DRAG_SCROLL) {
    document.addEventListener('pointerdown', (e) => {
      const container = getContainerFrom(e.target);
      if (!container) return;

      // só botão esquerdo no mouse; em touch/pen normalmente é undefined
      if (e.pointerType === 'mouse' && e.button !== 0) return;

      bootstrapContainers(container); // garante touch-action etc
      container.classList.add('badges--dragging');

      activeDrags.set(e.pointerId ?? -1, {
        container,
        startX: e.clientX ?? 0,
        startY: e.clientY ?? 0,
        startScrollLeft: container.scrollLeft,
        movedHoriz: false,
        isTouchLike: (e.pointerType === 'touch' || e.pointerType === 'pen')
      });
    }, { capture: true });

    document.addEventListener('pointermove', (e) => {
      const state = activeDrags.get(e.pointerId ?? -1);
      if (!state) return;

      const x  = e.clientX ?? 0;
      const y  = e.clientY ?? 0;
      const dx = x - state.startX;
      const dy = y - state.startY;

      const threshold = state.isTouchLike ? TOUCH_DRAG_THRESHOLD_PX : MOUSE_DRAG_THRESHOLD_PX;

      // só entra em modo “drag horizontal” quando for claramente horizontal
      if (!state.movedHoriz) {
        if (Math.abs(dx) > threshold && Math.abs(dx) > Math.abs(dy) * DRAG_DOMINANCE) {
          state.movedHoriz = true;
        } else {
          return; // ainda não “assumimos” o gesto
        }
      }

      // em mobile, impedir scroll nativo durante o drag horizontal
      e.preventDefault?.();

      state.container.scrollLeft = state.startScrollLeft - dx;
    }, { capture: true, passive: false });

    function endDrag(e) {
      const state = activeDrags.get(e.pointerId ?? -1);
      if (!state) return;

      const { container, movedHoriz } = state;

      container.classList.remove('badges--dragging');

      if (movedHoriz) {
        // arraste real: suprimir o clique subsequente
        justDragged.add(container);
        setTimeout(() => { try { justDragged.delete(container); } catch(_) {} }, 0);
      }

      activeDrags.delete(e.pointerId ?? -1);
    }

    document.addEventListener('pointerup', endDrag, { capture: true });
    document.addEventListener('pointercancel', endDrag, { capture: true });

    // Suprime apenas o clique imediatamente após um arraste real
    document.addEventListener('click', (e) => {
      const container = getContainerFrom(e.target);
      if (!container) return;
      if (justDragged.has(container)) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, { capture: true });
  }

  // ===== Atualizar links e imagens do card quando clicar no swatch =====
  document.addEventListener('click', (e) => {
    const label = e.target && e.target.closest('.product-card-layout-02 .card-swatch .swatch-label');
    if (!label) return;

    const variantId = label.getAttribute('data-variant-id') || label.dataset.variantId;
    if (!variantId) return;

    // card raiz
    const card = label.closest('.card');
    if (!card) return;

    // 1) Atualiza imagens (principal + hover) para a variante selecionada
    updateCardImagesForVariant(card, label);

    // 2) Atualiza todos os links para ?variant=ID
    const links = card.querySelectorAll('a.card-link, a.card-title');
    links.forEach((a) => {
      try {
        const rawHref = a.getAttribute('href') || a.dataset.productUrl || '';
        if (!rawHref) return;

        const url = new URL(rawHref, window.location.origin);
        url.searchParams.set('variant', String(variantId));
        const newHref = url.pathname + (url.search || '');

        a.setAttribute('href', newHref);
        if (a.dataset && 'productUrl' in a.dataset) a.dataset.productUrl = newHref;
      } catch (_) {
        const base = (a.getAttribute('href') || '').split('?')[0];
        if (base) {
          const newHref = `${base}?variant=${encodeURIComponent(String(variantId))}`;
          a.setAttribute('href', newHref);
          if (a.dataset && 'productUrl' in a.dataset) a.dataset.productUrl = newHref;
        }
      }
    });
  });
})();

/* ====== PDP: ativar scroll horizontal/drag nos swatches ====== */
(function () {
  'use strict';

  // Seletoras comuns na PDP (pode ajustar se seu tema usar outros)
  const LISTS = [
    '.main-product .product-form__swatch-list',
    '.main-product .product-form__input .swatch__list',
    '.main-product .product-form__input .swatches',
    '.main-product .product-form__input .swatch-list',
    '.main-product .swatch-list .swatch',
    '.main-product .swatches .swatch',
    '.main-product .nt-swatch .swatch_list'
  ];

  const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));

  function enhanceTrack(track) {
    if (!track || track.__swatchEnhanced) return;
    track.__swatchEnhanced = true;

    // Mesma lógica do card: faixa única com scroll horizontal
    track.style.display = 'flex';
    track.style.flexWrap = 'nowrap';
    track.style.alignItems = 'center';
    track.style.whiteSpace = 'nowrap';
    track.style.gap = track.style.gap || '8px 10px';
    track.style.boxSizing = 'border-box';
    track.style.overflowX = 'auto';
    track.style.overflowY = 'hidden';
    track.style.webkitOverflowScrolling = 'touch';
    track.style.scrollBehavior = 'smooth';
    track.style.padding = track.style.padding || '2px';
    track.style.cursor = 'grab';

    // Confinar qualquer estouro ao bloco de info/form (evita “jogo” da página)
    const parent = track.closest('.product-form, .product-info, .product__info, .product-form__input');
    if (parent) {
      parent.style.maxWidth = '100%';
      parent.style.boxSizing = 'border-box';
      parent.style.minWidth = '0';
      if (window.matchMedia('(min-width:1025px)').matches) {
        parent.style.overflowX = 'clip';
      }
    }

    // Arraste com mouse (desktop)
    let down = false, startX = 0, startLeft = 0;
    track.addEventListener('pointerdown', (e) => {
      down = true;
      track.setPointerCapture?.(e.pointerId);
      startX = e.clientX;
      startLeft = track.scrollLeft;
      track.style.cursor = 'grabbing';
    }, { passive: true });

    track.addEventListener('pointermove', (e) => {
      if (!down) return;
      const dx = e.clientX - startX;
      track.scrollLeft = startLeft - dx;
      e.preventDefault();
    }, { passive: false });

    const end = () => { down = false; track.style.cursor = 'grab'; };
    track.addEventListener('pointerup', end, { passive: true });
    track.addEventListener('pointerleave', end, { passive: true });

    // Roda do mouse = scroll horizontal
    track.addEventListener('wheel', (e) => {
      if (Math.abs(e.deltaX) < Math.abs(e.deltaY)) {
        track.scrollLeft += e.deltaY;
        e.preventDefault();
      }
    }, { passive: false });
  }

  function init(root = document) {
    LISTS.forEach(sel => qsa(sel, root).forEach(enhanceTrack));
    // Itens não “esticam” a linha
    qsa(`
      .main-product .swatch__item,
      .main-product .nt_swatch_item,
      .main-product .swatch .item,
      .main-product .nt-swatch .swatch_list .item,
      .main-product .swatch-list .item,
      .main-product .product-form__input input[type="radio"] + label
    `, root).forEach(el => { el.style.flex = '0 0 auto'; el.style.boxSizing = 'border-box'; });
  }

  // 1ª carga
  init();

  // Após trocas de variante via JS (swap parcial), re-aplica
  document.addEventListener('vianelli:variant:updated', () => init());
  // Themes/chunks que atualizam DOM: MutationObserver garante re-init
  const mo = new MutationObserver(() => init());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
